import { StreamHandler } from "./stream.handler";
import { SubscribeMissionProgress, UpdateMissionProgress } from "@/types";
import type { MissionProgressSchema } from "@/types";
import { useAppStore } from "@/stores";
import { recomputeSprintMissions, recomputeMissions } from "@/stores/derive";

/**
 * `mission_progress` — the missions-specific volatile stream (per-player
 * mission/task state, ~1s cadence; deliberately carries no prizes). Feeds
 * `missionProgressById`; the assembled `missionsCampaigns` view is re-derived
 * on change.
 */
export class MissionProgressHandler extends StreamHandler<
  MissionProgressSchema[]
> {
  protected readonly subscribeType = SubscribeMissionProgress;
  protected readonly updateType = UpdateMissionProgress;

  protected isBusy(): boolean {
    const s = useAppStore.getState().missionProgressStream;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setMissionProgressLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setMissionProgressSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearMissionProgress();
    recomputeMissions();
    recomputeSprintMissions();
  }
  protected apply(data: MissionProgressSchema[]): void {
    useAppStore.getState().setMissionProgress(data);
    recomputeMissions();
    recomputeSprintMissions();
  }
}

export const missionProgressHandler = new MissionProgressHandler();
